jQuery(document).ready(function () {
  
    if ($('.methodologie').length > 0) {
   
        function changeDisplay(){
            if ($('.methodologie_check').length > 5) {
                $('.methodologie_check').addClass("methodologie_check-lot");
            }
        }
        changeDisplay();
    }
})